export default "__VITE_ASSET__Cp33PVul__"